import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <div>
    <div className="container-fluid bg-dark footer py-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="container py-3">
            <div className="row g-5">
                <div className="col-lg-4 col-md-6">
                    <h5 className="text-uppercase text-light mb-4">Our Office</h5>
                    <p className="mb-2"><i className="fa fa-map-marker-alt text-primary me-1"></i>11-A, Birdwood Link Lawrence Road, Lahore</p>
                    <p className="mb-2"><i className="fa fa-phone-alt text-primary me-1"></i>042-35464418</p>
                    <p className="mb-2"><i className="fa fa-envelope text-primary me-1"></i>Info@hbmco.net</p>
                </div>
                <div className="col-lg-4 col-md-6">
                    <h5 className="text-uppercase text-light mb-4">Quick Links</h5>
                    <Link className="btn btn-link" to="/">Home</Link>
                    <Link className="btn btn-link" to="/about">About</Link>
                    <a className="btn btn-link" href="">Expertise</a>
                    <a className="btn btn-link" href="">Team</a>
                    <a className="btn btn-link" href="">Contact</a>
                </div>
                <div className="col-lg-4 col-md-6">
                    <h5 className="text-uppercase text-light mb-4">Business Hours</h5>
                    <p className="text-uppercase mb-0">Monday - Friday</p>
                    <p>09:00 am - 06:00 pm</p>
                    <p className="text-uppercase mb-0">Saturday, Sunday</p>
                    <p>Closed</p>
                </div>
            </div>
        </div>
    </div>

    <div className="container-fluid text-body copyright py-4">
        <div className="container">
            <div className="row">
                <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                    &copy; <a className="fw-semi-bold" href="#">HBM</a>, All Right Reserved.
                </div>
            </div>
        </div>
    </div>


    <a href="#" className="btn btn-lg btn-primary btn-lg-square back-to-top"><i
            className="bi bi-arrow-up"></i></a>


    <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.1/jquery.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0/dist/js/bootstrap.bundle.min.js"></script>
    <script src="lib/wow/wow.min.js"></script>
    <script src="lib/easing/easing.min.js"></script>
    <script src="lib/waypoints/waypoints.min.js"></script>
    <script src="lib/counterup/counterup.min.js"></script>
    <script src="lib/owlcarousel/owl.carousel.min.js"></script>

    <script src="js/main.js"></script>
    </div>
  )
}
